module.exports = __webpack_public_path__ + "static/media/business.a183bcdd.png";